export type MatchGraphic = {
  template: string;
  theme: { primary: string; accent: string; paper: string };
  home: { name: string; short: string; crestUrl: string };
  away: { name: string; short: string; crestUrl: string };
  competition: string;
  venue?: string;
  kickoff?: string;
  score?: [number, number];
  scorer?: { name: string; minute: number };
  lineup?: string[];
  subs?: string[];
  playerPhotoUrl?: string;
  scenePhotoUrl?: string;
  sponsor?: { label: string; logoUrl?: string };
};

export const RENDER_BASE_URL = (import.meta.env.VITE_RENDER_BASE_URL as string | undefined)?.replace(
  /\/$/,
  "",
);

async function postRender(path: string, data: MatchGraphic, signal?: AbortSignal): Promise<Blob> {
  if (!RENDER_BASE_URL) {
    throw new Error("Der Grafik-Dienst ist nicht konfiguriert (VITE_RENDER_BASE_URL fehlt).");
  }
  const res = await fetch(`${RENDER_BASE_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ template: data.template, data }),
    signal,
  });
  if (!res.ok) {
    throw new Error(`Der Grafik-Dienst hat mit Fehler ${res.status} geantwortet.`);
  }
  return await res.blob();
}

export const renderPng = (data: MatchGraphic, signal?: AbortSignal) =>
  postRender("/render", data, signal);

export const renderMp4 = (data: MatchGraphic, signal?: AbortSignal) =>
  postRender("/render-mp4", data, signal);

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
